/**
 * Created by Josef Jurca on 2.11.2017.
 */

import {ActionTypes, DeviceStatuses} from '../actions/device';

const defaultState = {
    device: {},
    status: DeviceStatuses.INITIAL
};


/**
 * Returns the device state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
function device (state = {}, action) {
    switch (action.type) {

        case ActionTypes.SET_DEVICE:
            return Object.assign({}, state, action.device);

        default:
            return state;
    }
}

/**
 * Returns the device status state.
 *
 * @param {string} state - Current state.
 * @param {Object} action - Action object.
 * @returns {string} State.
 */
function status (state = DeviceStatuses.INITIAL, action) {
    switch (action.type) {

        case ActionTypes.SET_DEVICE_STATUS:
            return (state = action.status);

        default:
            return state;
    }
}

/**
 * Returns the linear channels state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
export default function linearChannels (state = defaultState, action) {
    return {
        device: device(state.device, action),
        status: status(state.status, action)
    };
}


// WEBPACK FOOTER //
// ./src/js/store/reducers/device.js